export var XScalarStability;
(function (XScalarStability) {
    XScalarStability["Deprecated"] = "deprecated";
    XScalarStability["Experimental"] = "experimental";
    XScalarStability["Stable"] = "stable";
})(XScalarStability || (XScalarStability = {}));
